import { Component } from '@angular/core';

import { HttpPagination } from '@library/common/http';
import { BreakpointService } from '@library/core/services';

@Component({
   selector: 'lib-http-pagination',
   inputs: [ 'diameter' ],
   templateUrl: './http-pagination.component.html',
   styleUrls: ['./http-pagination.component.scss']
})
export class HttpPaginationComponent {

   diameter = 70;

   constructor(
      public pagination: HttpPagination,
      public breakpoints: BreakpointService,
   ) { }
}
